import { render, staticRenderFns } from "./Nodisponibles.vue?vue&type=template&id=105cb3f2"
import script from "./Nodisponibles.vue?vue&type=script&lang=js"
export * from "./Nodisponibles.vue?vue&type=script&lang=js"
import style0 from "./Nodisponibles.vue?vue&type=style&index=0&id=105cb3f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports